var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 13.334H14.1668C13.7066 13.334 13.3335 13.7071 13.3335 14.1673V17.5007C13.3335 17.9609 13.7066 18.334 14.1668 18.334H17.5002C17.9604 18.334 18.3335 17.9609 18.3335 17.5007V14.1673C18.3335 13.7071 17.9604 13.334 17.5002 13.334Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 13.334H2.50008C2.03984 13.334 1.66675 13.7071 1.66675 14.1673V17.5007C1.66675 17.9609 2.03984 18.334 2.50008 18.334H5.83341C6.29365 18.334 6.66675 17.9609 6.66675 17.5007V14.1673C6.66675 13.7071 6.29365 13.334 5.83341 13.334Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.66699H8.33333C7.8731 1.66699 7.5 2.04009 7.5 2.50033V5.83366C7.5 6.2939 7.8731 6.66699 8.33333 6.66699H11.6667C12.1269 6.66699 12.5 6.2939 12.5 5.83366V2.50033C12.5 2.04009 12.1269 1.66699 11.6667 1.66699Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 13.3337V10.8337C4.16675 10.6126 4.25455 10.4007 4.41083 10.2444C4.56711 10.0881 4.77907 10.0003 5.00008 10.0003H15.0001C15.2211 10.0003 15.4331 10.0881 15.5893 10.2444C15.7456 10.4007 15.8334 10.6126 15.8334 10.8337V13.3337M10.0001 10.0003V6.66699",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIconW);
export default __webpack_public_path__ + "static/media/networkIconW.42f1a637ddef2312bb72d0a5bfc23704.svg";
export { ForwardRef as ReactComponent };